<template>
	<div class="m-ola">

		<!--视频 GO -->
		<div class="video">
			<video height="800" autoplay controls class="list_img" muted="muted"
				:src="zidiyiData.oriential_video.files" />
		</div>
		
		
		<!--东方大漆介绍 GO -->
		<div class="introduce">
			<div class="cont">
				<!--通用头部 GO-->
				<div class="commo_tit">
					<div class="tit_left">
						<div class="yipinyun-dec">
							<div class="logo">
								<img width="220" src="@/assets/img/ola-logo.png" />
							</div>
						</div>
						<div class="info_tit">

							<el-divider direction="vertical"></el-divider>
							<span>INTRODUCE</span>
						</div>

					</div>

				</div>
				<!-- 品牌介绍 -->
				<div class="txts row">
					<div class="txt col-xs-12 col-lg-12">
						<div class="js_nr"
							v-html="lang=='CN' ? zidiyiDataDes.ola_intro.cn_content:zidiyiDataDes.ola_intro.en_content">
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--活动资讯  展览预告 GO -->
		<div class="m-actives">
			<div class="wrap">
				<div class="top" @click="go_list(164)">
					<div class="top-left">
						{{lang=='CN' ?'活动资讯':'Activity information'}}
						<img src="@/assets/img/down-arrow.png" alt="">
					</div>
					<div class="top-right" :style="'background-image:url('+zidiyiData.ola_tit.files+')'"></div>
				</div>
				<div class="items">
					<div class="item first" v-for="item,index in archOneList"
						@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
						:key="item.id" v-if="index==0">
						<div class="pic">
							<img class="css3" :src="item.image" alt="">
						</div>
						<div class="info">
							<div class="tit">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
							<div class="txt">{{lang=='CN' ?item.cn_cont:item.en_cont}}</div>
							<div class="date">{{item.publishtime_text}}</div>
						</div>
					</div>
					<div class="item last" v-for="item,index in archOneList"
						@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
						:key="item.id" v-if="index>0">
						<div class="date">{{item.publishtime_text}}</div>
						<div class="tit">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
					</div>
				</div>
			</div>
			<div class="wrap last">
				<div class="top" @click="go_list(165)">
					<div class="top-left">
						{{lang=='CN' ?'展览预告':'Exhibition Preview'}}
					</div>
					<div class="top-right">
						<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
					</div>
				</div>
				<div class="item" v-for="item,index in archTwoList"
					@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)" :key="item.id">
					<div class="pic">
						<img class="css3" :src="item.image" alt="">
					</div>
					<div class="info">
						<div class="tit">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
						<div class="txt">{{lang=='CN' ?item.cn_cont:item.en_cont}}</div>
					</div>
				</div>
			</div>


		</div>

		<!--近期展览 GO -->
		<div class="m-recently">
			<div class="info_tit">
				<div class="tit_left">
					<span>东方大漆近期展览 </span>
					<el-divider direction="vertical"></el-divider>
					<span>Recently exhibitions</span>
				</div>
				<div class="tit_right" @click="go_list(169)">
					<span>查看更多</span>
					<el-divider direction="vertical"></el-divider>
					<span>MORE</span>
				</div>
			</div>

			<div class="cont">
				<swiper :options="swiperOption2" ref="mySwiper" :pagination="{clickable:true}"
					v-if="archSixList.length>0">
					<div class="swiper-slide css3" v-for="(item,index) in archSixList"
						@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
						:key="item.title">
						<div class="item css3">

							<img class="css3" :src="item.image" alt="" />

							<div class="info">
								<div class="num">0{{index+1}}</div>
								<div class="tit css3">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
								<div class="dot">···</div>
								<div class="txt css3">{{lang=='CN' ?item.cn_digest:item.en_digest}}
								</div>
							</div>

						</div>
					</div>
				</swiper>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination">
				</div>
				<!-- 如果需要导航按钮 -->
				<div class="swiper-button-prev2"></div>
				<div class="swiper-button-next2"></div>
				<!-- 如果需要滚动条 -->
				<div class="swiper-scrollbar">
				</div>

			</div>



		</div>




		<!--非遗研学 GO -->
		<div class="m-intangible-culturals">
			<div class="info_tit">
				<div class="tit_left">
					<span>非遗研学 </span>
					<el-divider direction="vertical"></el-divider>
					<span>Research on Intangible Cultural</span>
				</div>
				<div class="tit_right" @click="go_list(166)">
					<span>查看更多</span>
					<el-divider direction="vertical"></el-divider>
					<span>MORE</span>
				</div>
			</div>

			<div class="wrap  last">

				<div class="item" v-for="item,index in archThreeList"
					@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)" :key="item.id"
					v-if="index==0">
					<div class="pic">
						<img class="css3" :src="item.image" alt="">
					</div>
					<div class="info">
						<div class="tit">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
						<div class="txt">{{lang=='CN' ?item.cn_digest : item.en_digest}}</div>
					</div>
				</div>
			</div>

			<div class="wrap ml10">
				<div class="items">
					<div class="item first" v-for="item,index in archThreeList"
						@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
						:key="item.id" v-if="index==1">
						<div class="pic">
							<img class="css3" :src="item.image" alt="">
						</div>
						<div class="info">
							<div class="tit">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
							<div class="txt">{{lang=='CN' ?item.cn_digest : item.cn_digest}}</div>
						</div>
					</div>
					<div class="item last" v-for="item,index in archThreeList"
						@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)"
						:key="item.id" v-if="index>1">
						<div class="date spe css3">
							<!-- <div class="time">TIME</div> -->
							<div class="day">
								{{item.mon}}/{{item.day}}
							</div>
							<div class="year"><span>{{item.year}}</span></div>

						</div>

						<div class="info">
							<div class="tit">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
							<div class="txt">{{lang=='CN' ?item.cn_digest : item.cn_digest}}</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<!--常驻艺术家 GO -->
		<div class="m-artlist">
			<div class="title" @click="go_list(167)">
				<div class="tit">{{lang=='CN' ?'常驻艺术家':'Resident artist'}} </div>
				<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
			</div>
			<div class="ocupied"></div>

			<div class="cont">
				<swiper :options="swiperOption" ref="mySwiper" :pagination="{clickable:true}"
					v-if="archOneList.length>0">
					<div class="swiper-slide" v-for="(item,index) in archFourList" :key="item.title"
						@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
						<div class="item">
							<div class="photo"> <img :src="item.image" alt="">
							</div>
							<div class="name">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
							<div class="tit">{{lang=='CN' ?item.cn_digest:item.en_digest}}
							</div>
							<div class="icon">
								<img src="@/assets/img/right.png" />
							</div>
						</div>
					</div>
				</swiper>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination">
				</div>
				<!-- 如果需要导航按钮 -->
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
				<!-- 如果需要滚动条 -->
				<div class="swiper-scrollbar">
				</div>

			</div>
		</div>


		<!-- 展览作品 GO -->
		<div class="m-paint-art">
			<div class="cont">
				<div class="title" @click="go_list(168)">
					<div class="tit">{{lang=='CN' ?'展览作品':'Exhibition works'}} </div>
					<div class="more">{{lang=='CN' ?'更多':'More'}} + </div>
				</div>
				<div class="ocupied"></div>
				<div class="swiper-container">
					<swiper :options="swiperOption1" ref="mySwiper" :pagination="{clickable:true}"
						v-if="archFiveList.length>0">
						<div class="swiper-slide" v-for="(item,index) in archFiveList" :key="item.title"
							@click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
							<div class="item">
								<div class="photo"> <img :src="item.image" alt=""></div>
								<div class="txt">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
								<div class="date">{{lang=='CN' ? '制作时间/年份': 'createTime/Year:'}}
									{{item.publishtime_text}}
								</div>
							</div>
						</div>
					</swiper>
					<!-- 如果需要分页器 -->
					<div class="swiper-pagination1">
					</div>
					<!-- 如果需要导航按钮 -->
					<div class="swiper-button-prev1"></div>
					<div class="swiper-button-next1"></div>
					<!-- 如果需要滚动条 -->
					<div class="swiper-scrollbar1">
					</div>
				</div>
			</div>
		</div>



		<!-- 文创商城  GO-->
		<div class="pro-container">
			<div class="info_tit">
				<div class="tit_left">
					<span>文创商城 </span>
					<el-divider direction="vertical"></el-divider>
					<span>SHOPPING MALL</span>
				</div>
				<div class="tit_right" @click="goShop(11)">
					<span>查看更多</span>
					<el-divider direction="vertical"></el-divider>
					<span>MORE</span>
				</div>
			</div>
			<div class="row" v-if="proList.length>0">
				<div class="item  " v-for="(item,index) in proList" @click="goLink(item.outlink)">

					<div class="photos">
						<img class="photo" :src="item.image" />
						<div class="ewm css3">
							<img :src="item.ewm" />
							<div class="tips">
								{{lang=='CN' ?'扫码了解商品详情':'Find out details'}}
							</div>
						</div>
						<div class="mask css3"></div>
					</div>
					<div class="info">
						<div class="title line-2">{{lang=='CN' ? item.title: item.en_title}}</div>
						<div class="time">{{lang=='CN' ? '制作时间/年份': 'createTime/Year:'}}
							{{item.createtime_text}}
						</div>
					</div>

				</div>
			</div>
			<div class="row" v-else>
				暂无数据~
			</div>
		</div>


		<!--新闻资讯 GO-->
		<div class="news-list">
			<!-- 党群列表 GO -->
			<div class="pro-news">
				<div class="info_tit short">
					<div class="tit_left">
						<span>新闻资讯</span>
						<el-divider direction="vertical"></el-divider>
						<span>NEWS</span>
					</div>
					<div class="tit_right f14" @click="go_list(159)">
						<span>查看更多</span>
						<el-divider direction="vertical"></el-divider>
						<span>MORE</span>
					</div>
				</div>

				<!-- 列表 -->
				<div class="liebiao_list wow fadeInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>
					<div class="liebiao_info spe css3 wow fadeInUp animated" v-for="(item,index) in orientalList"
						data-wow-delay="0.5s" data-wow-offset='0' :key="index">
						<div class="info_left">
							<img class="css3" :src="item.image" @click="go(item.id)" />
						</div>
						<div class="info_right" @click="go(item.id)">
							<span class="right_tit1">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
							<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
							<div class="right_down">
								<span>{{item.publishtime_text}}</span>
								<div class="right_down_div">
									<span class="commo_span">
										<img class="eye" src="@/assets/news/eye.svg" />
										<span>{{item.view}}</span>
									</span>
									<span class="commo_span">
										<img src="@/assets/news/comment.svg" />
										<span>{{item.comment_num}}</span>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>

</template>


<script src="./static/js/moo.js" async></script>
<script src="./static/js/switchable.js" async></script>

<script>
	import moment from 'moment'
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper"

	import {
		archives_list
	} from '@/api/api.js'
	export default {
		components: {},
		name: 'new_detail',
		data() {
			return {
				lang: localStorage.getItem('lang') || 'CN',
				zidiyiData: {
					oriential_video: {
						files: ''
					},
					ola_tit: {
						files: ''
					},
				},
				
				zidiyiDataDes: {
					ola_intro: {
						cn_content: '',
						en_content: ''
					}
				},
				swiperOption: {
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 5,
					slidesPerGroup:1,
					// 显示分页
					// pagination: {
					//   el: ".swiper-pagination",
					//   clickable: true //允许分页点击跳转
					// },
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					}
				},

				swiperOption1: {
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 4,
					slidesPerGroup: 1,
					// 显示分页
					pagination: {
						el: ".swiper-pagination1",
						clickable: true //允许分页点击跳转
					},
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next1",
						prevEl: ".swiper-button-prev1"
					}
				},
				swiperOption2: {
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					slidesPerView: 'auto',
					centeredSlides: true,
					// spaceBetween: 30,
					// effect:'coverflow',
					loop: true,
					slideToClickedSlide: true, // 点击的slide会居中
					slidesPerView: 3,
					slidesPerGroup: 1,
					// 显示分页
					// pagination: {
					//   el: ".swiper-pagination",
					//   clickable: true //允许分页点击跳转
					// },
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next2",
						prevEl: ".swiper-button-prev2"
					},
					on: {
						// 该方法中的this都指代swiper本身
						tap: function() {
							console.log('点击的位置', this.activeIndex);
						}
					}
				},
				proList: [], //产品

				archOneList: [],
				archTwoList: [],
				archThreeList: [],
				archFourList: [],
				archFiveList: [],
				archSixList: [],
				
				total: '',
				orientalList: [], //内容列表
				company_id: 1, //公司ID
				per_page: 9,
				page: 1,

			}
		},
		filters: {
			formatDate: function(value) {
				return moment(value * 1000).format('YYYY-MM-DD')
			}
		},
		computed: {

		},

		created() {
			this.id = this.$route.query.id
			this.company_id = this.$route.query.id
			this.getZidiyiData();
			this.addLocatPath()
		},
		mounted() {
			this.getAllNewsList()
			this.getZidiyiDataDes()

			this.getArchivesList(159)
			this.getProductList()

		},
		methods: {

			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			// 获取自定义富文本
			getZidiyiDataDes() {
				let data = {
					keys: 'ola_intro,gywm'
				}
				this.$axios.get("/api/jx/get_content", {
					params: data
				}).then((res) => {

					this.zidiyiDataDes = res.data.data

				}).catch(err => {});
			},

			getAllNewsList() {
				let temp = [],
					data = {
						channel_id: '164,165,166,167,168,169',
						per_page: '5,1,5,10,8,9'
					}
				this.$axios.get("/api/jx/archives_list_new", {
					params: data
				}).then((res) => {

					temp = res.data.data
					this.archOneList = temp[0] ? temp[0].data : temp //活动资讯
					this.archTwoList = temp[1] ? temp[1].data : temp //展馆资讯
					this.archThreeList = temp[2] ? temp[2].data : temp //非遗研学
					this.archFourList = temp[3] ? temp[3].data : temp //常驻艺术家
					this.archFiveList = temp[4] ? temp[4].data : temp //展品展览
					this.archSixList = temp[5] ? temp[5].data : temp //展品展览



					this.archOneList.map(item => {
						item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
							.en_content)
						item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
							.cn_content)

					})

					this.archTwoList.map(item => {
						item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
							.en_content)
						item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
							.cn_content)

					})
					this.archThreeList.map(item => {
						item.year = item.publishtime_text.split("-")[0];
						item.mon = item.publishtime_text.split("-")[1];
						item.day = item.publishtime_text.split("-")[2];
					})

				}).catch(err => {});
			},


			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			goLink(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			getProductList(id) {
				let data = {
					company_id: 11,
					per_page: 8,
					page: 1
				}
				this.$axios.get("/api/jx/product_list", {
					params: data
				}).then((res) => {
					if (res.data.code == 1) {
						this.proList = res.data.data.data
						this.total = res.data.data.total
					}
				}).catch(err => {});
			},

			goShop(id) {
				this.$router.push({
					path: `shop`,
					query: {
						id: id
					}
				})
			},


			addLocatPath() {
				let data = {
					directions: '新闻详情',
					path: window.location.href
				}
				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {

				}).catch(err => {});
			},

			getArchivesList(id) {
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page
				}
				archives_list(data).then((res) => {

					res.data.data.map(e => {

						e.en_cont = e.en_digest ? e.en_digest : this.filtersText(e
							.en_content)
						e.cn_cont = e.cn_digest ? e.cn_digest : this.filtersText(e
							.cn_content)
					})

					this.orientalList = res.data.data
					this.total = res.data.total

				}).catch(err => {});
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},
			//更多
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},

			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}

				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {

					this.zidiyiData = res.data.data
				}).catch(err => {});
			},

			go_hotList() {
				this.$router.push({
					path: `hot`
				})
			},

		}
	}
</script>

<style lang="scss" scoped>
	/* 通用头部 GO*/
	.commo_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		.tit_left {
			display: flex;

			.yipinyun-dec {
				position: relative;

				.logo {
					.img {
						width: 120px;
						height: 50px;
						float: left;
					}
				}
			}

			.info_tit {
				position: relative;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				margin-top: 10px;
				cursor: pointer;

				.span {
					font-size: 30px;
					color: #999999;
					font-weight: bold;
				}
			}
		}
	}

	.m-ola {

		//头部视频
		.video {
			overflow: hidden;

			video {
				width: 100% !important;
				background: #000000;
				// object-fit: cover
			}

		}

		//东方大漆介绍
		.introduce {
			max-width: 1860px;
			margin: 20px auto 0px;
			position: relative;
			overflow: hidden;
			background: url(../assets/img/ola_bg1.jpg) 0 0 no-repeat;

			.cont {
				max-width: 1400px;
				margin: 100px auto 0;
				height: auto !important;
				position: relative;
			}

			.txts {
				margin: 10px 0 30px;
				font-size: 18px;
			}

			.txt {
				padding: 0;
				margin-top: 15px;
				height: 320px;
				overflow: hidden;
			}
		}

		.m-actives {
			width: 1400px;
			overflow: hidden;
			margin: 50px auto 0;

			.wrap {
				width: 50%;
				float: left;

				.top {
					width: 100%;
					height: 140px;
					line-height: 140px;
					cursor: pointer;

					.top-left {
						width: 160px;
						height: 140px;
						background: #c83629;
						position: relative;
						font-size: 24px;
						padding-left: 10px;
						color: #ffffff;
						float: left;

						&::before {
							content: '';
							width: 30px;
							background: #eee;
							display: block;
							height: 2px;
							position: absolute;
							top: 20px;
							left: 15px;
						}

						img {
							width: 32px;
							cursor: pointer;
							position: absolute;
							bottom: -16px;
							left: 50%;
							margin-left: -16px;
						}
					}

					.top-right {
						width: calc(100% - 160px);
						background-size: 100% 100%;
						height: 140px;
						float: left;
					}




				}

				.items {
					margin-top: 50px;

					.item {
						&.first {
							overflow: hidden;
							margin-bottom: 10px;

							.pic {
								width: 160px;
								height: 140px;
								float: left;
								cursor: pointer;
								overflow: hidden;

								img {
									width: 160px;
									height: 140px;

									&:hover {
										transform: scale(1.1);
										-webkit-transform: scale(1.1);
										-moz-transform: scale(1.1);
										-o-transform: scale(1.1);
										-ms-transform: scale(1.1);
									}
								}
							}

							.info {
								width: calc(100% - 160px);
								float: left;
								padding-left: 10px;
								padding: 0 10px;

								.tit {
									font-size: 18px;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 1;
									cursor: pointer;
									-webkit-box-orient: vertical;

									&:hover {
										color: #006170;
									}
								}

								.txt {
									margin-top: 10px;
									font-size: 14px;
									line-height: 25px;
									color: #999999;
									height: 75px;
									cursor: pointer;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 3;
									-webkit-box-orient: vertical;

									&:hover {
										color: #006170;
									}
								}

								.date {
									margin-top: 10px;
									color: #666666;
								}
							}

						}

						&.last {
							line-height: 50px;

							.tit {
								width: calc(100% - 160px);
								font-size: 16px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								cursor: pointer;
								-webkit-box-orient: vertical;
								float: left;

								&:hover {
									color: #006170;
								}
							}

							.date {
								width: 160px;
								color: #666666;
								float: left;
							}


						}

					}
				}

				&.last {
					background: #f4f4f4;

					.top {
						.top-left {
							background: none;
							color: #3f3f3f;

							&::before {
								background: #3f3f3f;
							}


						}

						.top-right {
							position: relative;

							.more {
								width: 80px;
								height: 35px;
								line-height: 35px;
								color: #000000;
								font-size: 16px;
								border: 1px solid #000000;
								position: absolute;
								top: 20px;
								right: 20px;
								text-align: center;
								float: right;
								cursor: pointer;

								&:hover {
									color: #ffffff;
									background: #000000;
								}
							}

						}
					}

					.item {
						padding: 0 20px 20px;

						.tit {
							margin-top: 10px;
							font-size: 18px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							cursor: pointer;
							-webkit-box-orient: vertical;

							&:hover {
								color: #006170;
							}
						}

						.txt {
							margin-top: 10px;
							font-size: 14px;
							line-height: 25px;
							color: #999999;
							height: 50px;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;

							&:hover {
								color: #006170;
							}
						}

						img {
							width: 100%;
							height: 300px;
							object-fit: cover;
						}
					}
				}
			}
		}

		.m-recently {
			width: 1400px;
			margin: 50px auto 0;

			.info_tit {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 37px;

				/deep/ .swiper-pagination-bullet {
					display: none;
				}

				.active {
					border: 2px solid #006170;
					box-shadow: 5px 7px 10px #cddadc;
					color: #000;
				}

				.tit_right {
					cursor: pointer;
				}

				.tit_left {
					span:first-child {
						font-size: 30px;
						color: #000;
						font-weight: bold;
					}

					span:last-child {
						font-size: 12px;
						color: #999;
					}
				}
			}

			.cont {
				position: relative;
				height: 500px;
				.swiper-container {
					width: 100%;
					height: 500px;
					position: relative;
					overflow: hidden;
					
					.swiper-slide {
						text-align: center;
						font-size: 18px;
						background: #fff;
						width: calc(100% / 3);
						background: #f6f8fc;
						display: -webkit-box;
						display: -ms-flexbox;
						display: -webkit-flex;
						display: flex;
						-webkit-box-pack: center;
						-ms-flex-pack: center;
						-webkit-justify-content: center;
						justify-content: center;
						-webkit-box-align: center;
						-ms-flex-align: center;
						-webkit-align-items: center;
						align-items: center;

						.item {
							width: 100%;
							height: 500px;
							// overflow: hidden;
							margin-right: 20px;
							float: left;
							cursor: pointer;
							position: relative;

							.info {
								width: 100%;
								height: 500px;

								.num {
									margin-top: 50px;
									text-align: left;
									padding-left: 40px;
									font-size: 80px;
									font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
									color: #d8d9e3;

								}

								.tit {
									text-align: left;
									height: 45px;
									font-size: 36px;
									line-height: 45px;
									color: #3f3f3f;
									overflow: hidden;
									margin-top: 20px;
									padding-left: 40px;
									overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
								}

								.dot {
									padding-left: 40px;
									text-align: left;
									color: #f3c04d;
									font-size: 40px;
								}

								.txt {
									font-size: 18px;
									line-height: 40px;
									height: 120px;
									color: #757388;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 3;
									font-size: 16px;
									-webkit-box-orient: vertical;
									margin: 0 10px;
									padding: 0 20px;
								}

							}

							img {
								width: 0%;
								height: 0px;
								object-fit: cover;
								transition: all 0.7s ease 0s;
								-webkit-transition: all 0.7s ease 0s;
								-moz-transition: all 0.7s ease 0s;
								-o-transition: all 0.7s ease 0s;
								transform: rotate(180deg) scale(0);
								-webkit-transform: rotate(180deg) scale(0);
								-moz-transform: rotate(180deg) scale(0);
								-o-transform: rotate(180deg) scale(0);
								-ms-transform: rotate(180deg) scale(0);
								float: left;
								margin: 30px 0 0 60px;
								border: 4px solid #ffffff;
								position: relative;

							}



							.icon {
								width: 48px;
								height: 48px;
								padding-left: 10px;

								img {
									width: 48px;
									height: 48px;
								}
							}

						}


					}

					.swiper-slide-prev {
						width: 20% !important;
						transition: all 0.7s ease 0s;
						-webkit-transition: all 0.7s ease 0s;
						-moz-transition: all 0.7s ease 0s;
						-o-transition: all 0.7s ease 0s;
					}

					.swiper-slide-active {
						width: 60% !important;
						background: #4368e6;
						transition: all 0.7s ease 0s;
						-webkit-transition: all 0.7s ease 0s;
						-moz-transition: all 0.7s ease 0s;
						-o-transition: all 0.7s ease 0s;

						.item {
							img {
								width: 380px;
								height: 440px;
								object-fit: cover;
								transition: all 0.7s ease 0s;
								-webkit-transition: all 0.7s ease 0s;
								-moz-transition: all 0.7s ease 0s;
								-o-transition: all 0.7s ease 0s;
								transform: rotate(0deg) scale(1);
								-webkit-transform: rotate(0deg) scale(1);
								-moz-transform: rotate(0deg) scale(1);
								-o-transform: rotate(0deg) scale(1);
								-ms-transform: rotate(0deg) scale(1);
							}

							.info {
								width: 330px;
								float: left;
								.dot,
								.tit,
								.txt {
									color: #ffffff;
								}
							}
						}



					}

					.swiper-slide-next {
						width: 20% !important;
						transition: all 0.7s ease 0s;
						-webkit-transition: all 0.7s ease 0s;
						-moz-transition: all 0.7s ease 0s;
						-o-transition: all 0.7s ease 0s;
					}


				}

				.swiper-button-prev2,
				.swiper-button-next2 {
					width: 60px;
					height: 60px;
					left: 50%;
					top: 50%;
					position: absolute;
					bottom: 70px;
					z-index: 99;
					margin-top: -30px;
				}

				.swiper-button-prev2::after,
				.swiper-button-next2::after {
					// display: none;
				}

				.swiper-button-prev2 {
					background:url(~@/assets/img/prevnext2.png) 0 0 no-repeat;
					margin-left: -450px;
				}

				.swiper-button-next2 {
					background:url(~@/assets/img/prevnext2.png)  -60px 0 no-repeat;
					margin-left: 390px;
				}

				.swiper-button-prev2:hover,
				.swiper-button-next2:hover {
					opacity: 0.8;
				}


			}







		}

		.m-intangible-culturals {
			width: 1400px;
			overflow: hidden;
			margin: 50px auto 0;

			.info_tit {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 37px;

				/deep/ .swiper-pagination-bullet {
					display: none;
				}

				.active {
					border: 2px solid #006170;
					box-shadow: 5px 7px 10px #cddadc;
					color: #000;
				}

				.tit_right {
					cursor: pointer;
				}

				.tit_left {
					span:first-child {
						font-size: 30px;
						color: #000;
						font-weight: bold;
					}

					span:last-child {
						font-size: 12px;
						color: #999;
					}
				}
			}

			.wrap {
				width: 49.5%;
				float: left;

				&.ml10 {
					margin-left: 1%;
				}

				.items {
					.item {
						&.first {
							overflow: hidden;
							margin-bottom: 10px;

							.pic {
								width: 160px;
								height: 140px;
								float: left;
								cursor: pointer;
								overflow: hidden;

								img {
									width: 160px;
									height: 140px;

									&:hover {
										transform: scale(1.1);
										-webkit-transform: scale(1.1);
										-moz-transform: scale(1.1);
										-o-transform: scale(1.1);
										-ms-transform: scale(1.1);
									}
								}
							}

							.info {
								width: calc(100% - 160px);
								float: left;
								padding-left: 10px;
								padding: 0 10px;

								.tit {
									font-size: 18px;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 1;
									cursor: pointer;
									-webkit-box-orient: vertical;

									&:hover {
										color: #006170;
									}
								}

								.txt {
									margin-top: 10px;
									font-size: 14px;
									line-height: 25px;
									color: #999999;
									height: 75px;
									cursor: pointer;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 3;
									-webkit-box-orient: vertical;

									&:hover {
										color: #006170;
									}
								}

								.date {
									margin-top: 10px;
									color: #666666;
								}
							}

						}

						&.last {
							cursor: pointer;
							height: 120px;
							margin-top: 30px;

							&:hover {
								background: #f4f4f4;
							}

							.date {
								width: 160px;
								color: #666666;
								float: left;
								height: 120px;
								text-align: center;
								border-right: 1px solid #e6e8ea;

								.time {}

								.year {
									line-height: 30px;
									color: #006170;
									font-size: 24px;
									margin-top: 10px;
									position: relative;

									&::before {
										width: 40px;
										height: 1px;
										overflow: hidden;
										background: #006170;
										display: block;
										position: absolute;
										top: 15px;
										left: 25px;
										content: '';
									}

									span {
										margin-left: 50px;
									}
								}

								.day {

									line-height: 30px;
									color: #006170;
									font-size: 36px;
									font-weight: bold;
									margin-top: 30px;
									letter-spacing: 5px;
								}
							}

							.info {
								width: calc(100% - 160px);
								float: left;
								overflow: hidden;
								padding-left: 10px;
							}

							.tit {
								width: 100%;
								font-size: 16px;
								padding-top: 10px;
								line-height: 30px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								cursor: pointer;
								-webkit-box-orient: vertical;

								&:hover {
									color: #006170;
								}
							}

							.txt {
								margin-top: 30px;
								color: #999999;
							}



						}

					}
				}

				&.last {
					.item {
						.info {
							margin-bottom: 20px;
						}

						.tit {
							line-height: 60px;
							border-bottom: 1px solid #e6e8ea;
							font-size: 18px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							cursor: pointer;
							-webkit-box-orient: vertical;

							&:hover {
								color: #006170;
							}
						}

						.txt {
							margin-top: 25px;
							font-size: 14px;
							line-height: 25px;
							color: #999999;
							height: 50px;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;

							&:hover {
								color: #006170;
							}
						}

						img {
							width: 100%;
							height: 460px;
							object-fit: cover;
						}
					}
				}
			}
		}

		/**
	 * 常驻艺术家
	 */
		.m-artlist {
			max-width: 100%;
			background: #0b2143;
			margin: 20px auto 0;
			position: relative;
			overflow: hidden;
			height: 900px;

			.ocupied {
				width: 100%;
				height: 1px;
			}

			.title {

				margin-top: 50px;
				overflow: hidden;

				.more {
					width: 80px;
					height: 35px;
					line-height: 35px;
					color: #ffffff;
					font-size: 16px;
					border: 1px solid #ffffff;
					text-align: center;
					float: right;
					margin-right: 100px;
					cursor: pointer;
				}

				.tit {
					margin-left: 100px;
					font-size: 30px;
					color: #ffffff;
					float: left;
					position: relative;
				}

				.tit::before {
					width: 16px;
					height: 36px;
					overflow: hidden;
					background: url(../assets/img/tit-bg.png) 0 -36px no-repeat;
					display: block;
					position: absolute;
					top: 3px;
					left: -30px;
					content: '';
				}

				.tit::after {
					width: 16px;
					height: 36px;
					overflow: hidden;
					background: url(../assets/img/tit-bg.png) -16px -36px no-repeat;
					display: block;
					position: absolute;
					top: 3px;
					right: -30px;
					content: '';
				}

				.more:hover {
					color: #ffffff;
					background: #831c1f;
				}

			}

			.cont {
				width: 1800px;
				padding: 50px 50px 0;
				overflow: hidden;
				margin: 0 auto;

				.item {
					width: 320px;
					height: 600px;
					overflow: hidden;
					margin-right: 20px;
					float: left;
					background: #1b2d57;
					cursor: pointer;
					position: relative;

					.name {
						height: 45px;
						line-height: 45px;
						padding: 0 20px;
						display: inline-block;
						position: absolute;
						top: 340px;
						left: 0px;
						background: #ffce74;
						color: #3f3f3f;
						overflow: hidden;
					}

					img {
						width: 280px;
						height: 350px;
						margin: 20px;
						object-fit: cover;
					}

					.tit {
						font-size: 18px;
						line-height: 40px;
						height: 120px;
						color: #ffffff;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						font-size: 16px;
						-webkit-box-orient: vertical;
						margin: 0 10px;
						padding: 0 20px;
					}

					.icon {
						width: 48px;
						height: 48px;
						padding-left: 10px;

						img {
							width: 48px;
							height: 48px;
						}
					}

				}

				.swiper-button-prev,
				.swiper-button-next {
					width: 100px;
					height: 35px;
					left: 50%;
					top: initial;
					position: absolute;
					bottom: 70px;

				}

				.swiper-button-prev::after,
				.swiper-button-next::after {
					display: none;
				}

				.swiper-button-prev {

					background: #005fc5 url(~@/assets/img/prevnext1.png) center 0 no-repeat;
					margin-left: -50px;
				}

				.swiper-button-next {
					background: #204378 url(~@/assets/img/prevnext1.png) center -35px no-repeat;
					margin-left: 50px;
				}

				.swiper-button-prev:hover,
				.swiper-button-next:hover {
					background-color: rgba(0, 97, 112, .5);
				}

				.swiper-slide {
					height: 600px;
				}


			}


		}

		/**
	 * 展览作品
	 */
		.m-paint-art {
			max-width: 1860px;
			height: 736px;
			background-image: url(../assets/img/ola_bg2.jpg);
			background-size: 100% 100%;
			margin: 20px auto 0;
			position: relative;
			overflow: hidden;

			.ocupied {
				width: 100%;
				height: 1px;
			}

			.swiper-container {
				width: 1600px;
				height: 580px;
				margin: 40px auto 0;

			}

			.swiper-slide {
				cursor: pointer;
			}

			/deep/ .swiper-pagination1 {
				bottom: 60px;
				position: relative;
				text-align: center;
			}

			/deep/ .swiper-pagination-bullet {
				width: 80px;
				height: 4px;
				background: #bfbfbf;
				margin-left: 10px;
				border-radius: 0;
			}

			/deep/ .swiper-pagination-bullet-active {
				background: #000000;
			}

			.title {
				font-size: 30px;
				color: #000000;
				margin-top: 60px;

				.more {
					width: 80px;
					height: 35px;
					line-height: 35px;
					color: #000000;
					font-size: 16px;
					border: 1px solid #796638;
					text-align: center;
					float: right;
					cursor: pointer;
				}

				.tit {
					font-size: 30px;
					color: #000000;
					float: left;
					position: relative;
				}

				.tit::before {
					width: 16px;
					height: 36px;
					overflow: hidden;
					background: url(../assets/img/tit-bg.png) 0 -36px no-repeat;
					display: block;
					position: absolute;
					top: 3px;
					left: -30px;
					content: '';
				}

				.tit::after {
					width: 16px;
					height: 36px;
					overflow: hidden;
					background: url(../assets/img/tit-bg.png) -16px -36px no-repeat;
					display: block;
					position: absolute;
					top: 3px;
					right: -30px;
					content: '';
				}

				.more:hover {
					color: #ffffff;
					background: #831c1f;
				}

			}

			.cont {
				width: 1600px;
				height: 610px;
				margin: 60px auto;
			}

			.swiper-slide {
				width: 405px !important;
				overflow: hidden;
				position: relative;
				margin-bottom: 10px;
				float: left;
			}

			.item {
				width: 405px;
				overflow: hidden;
				position: relative;
				margin-bottom: 10px;

			}

			.photo {
				width: 380px;
				height: 380px;
				overflow: hidden;
				object-fit: cover;

				img {
					width: 380px;
					height: 380px;
					overflow: hidden;
					object-fit: cover;
				}
			}

			.txt {
				width: 380px;
				margin-top: 25px;
				height: 30px;
				line-height: 30px;
				color: #333333;
				font-size: 18px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}

			.txt:hover {
				color: #006170;
				cursor: pointer;
			}

			.date {
				margin-top: 10px;
				font-size: 14px;
				color: #666666;
			}

			.date:hover {
				color: #666666;
			}

		}

		/* 商城 GO*/
		.pro-container {
			width: 1400px;
			margin: 90px auto 0px;

			.info_tit {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 37px;

				/deep/ .swiper-pagination-bullet {
					display: none;
				}

				.active {
					border: 2px solid #006170;
					box-shadow: 5px 7px 10px #cddadc;
					color: #000;
				}

				.tit_right {
					cursor: pointer;
				}

				.tit_left {
					span:first-child {
						font-size: 30px;
						color: #000;
						font-weight: bold;
					}

					span:last-child {
						font-size: 12px;
						color: #999;
					}
				}
			}

			.item {
				width: 320px;
				overflow: hidden;
				position: relative;
				margin-bottom: 10px;
				float: left;
				margin: 0 0 30px 40px;

				&:nth-child(4n+1) {
					margin-left: 0px;
				}

				&:hover {
					.mask {
						opacity: 1;
					}
				}

				.title {
					margin-top: 25px;
					height: 30px;
					line-height: 30px;
					color: #333333;
					font-size: 18px;

					&:hover {
						color: #006170;
						cursor: pointer;
					}
				}

				.photos {
					width: 100%;
					height: 320px;
					position: relative;
					overflow: hidden;

					.photo {
						width: 100%;
						height: 320px;
						object-fit: cover;

					}
				}

				.ewm {
					width: 200px;
					height: 200px;
					position: absolute;
					top: 40px;
					left: 50%;
					z-index: 3;
					margin: 0px 0 0 -100px;
					transform: scale(0);
					-webkit-transform: scale(0);
					-moz-transform: scale(0);
					-o-transform: scale(0);
					-ms-transform: scale(0);

					img {
						width: 200px;
						height: 200px;
						object-fit: cover;
					}
				}

				&:hover {
					.ewm {
						transform: scale(1);
						-webkit-transform: scale(1);
						-moz-transform: scale(1);
						-o-transform: scale(1);
						-ms-transform: scale(1);
					}
				}

				.tips {
					width: 100%;
					line-height: 60px;
					font-size: 18px;
					color: #ffffff;
					text-align: center;
				}

				a {
					display: block;

				}

				.time {
					margin-top: 10px;
					color: #666666;
					font-size: 14px;

					&:hover {
						color: #666666;
					}
				}

				.mask {
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 2;
					opacity: 0;
					background: rgba(0, 0, 0, .5);
				}
			}
		}

		//新闻资讯
		.news-list {
			margin: 50px auto;
			width: 1430px;
		}


	}


	.m-ola .right_tit {
		background: #006170;
		width: 100%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		color: #fff;
		margin-bottom: 10px;
	}

	.m-ola .right_info {
		overflow: hidden;
	}

	.m-ola .right_info .wrap {
		overflow: hidden;
	}


	.m-ola .tit_span {
		display: block;
		margin-bottom: 10px;
		font-size: 14px;
		height: 60px;
		line-height: 30px;
		color: #333;
	}


	.m-ola .more_btn {
		font-size: 14px;
		color: #666;
		height: 50px;
		line-height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ebf3f5;
		font-weight: bold;
		cursor: pointer;
		margin-top: 10px;
	}

	.m-ola .more_btn span {
		position: relative;
		top: -1px;
		background: url(~@/assets/img/arrows_gray.png) center no-repeat;
	}

	.m-ola .more_btn:hover {
		color: #ffffff;

	}


	.m-ola .more_btn:hover span {
		color: #ffffff;
		background: url(~@/assets/img/arrows_white.png) center no-repeat;
	}



	.m-ola .more_btn img {
		width: 20px;
		height: 20px;
	}

	.m-ola .more_btn span:nth-child(2) {
		padding: 0 10px;
	}

	.m-ola .el-divider {
		background-color: #000 !important;
	}

	.info_right {
		width: 230px;
	}

	/* 新闻资讯 GO */
	.pro-news {
		margin-top: 50px;
		position: relative;
		left: 0px;

		.info_tit {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			/deep/ .swiper-pagination-bullet {
				display: none;
			}

			.active {
				border: 2px solid #006170;
				box-shadow: 5px 7px 10px #cddadc;
				color: #000;
			}

			.tit_right {
				cursor: pointer;
			}

			.tit_left {
				span:first-child {
					font-size: 30px;
					color: #000;
					font-weight: bold;
				}

				span:last-child {
					font-size: 12px;
					color: #999;
				}
			}
		}

		.liebiao_list {
			margin: 20px 0 0 -30px;

			.liebiao_info {
				width: calc(100% + 60px);
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				padding: 30px 30px 30px 30px;
				cursor: pointer;
				position: relative;
				left: 0px;

				&:hover {
					background: #f0f4f5;
				}

				&::after {
					width: calc(100% - 60px);
					height: 1px;
					content: '';
					background: #f0f4f5;
					display: block;
					position: absolute;
					bottom: 0px;
				}

				.info_left {
					width: 320px;
					height: 180px;
					margin-right: 0px;

					img {
						width: 320px;
						height: 180px;

					}
				}

				.info_right {
					width: calc(100% - 350px);
					height: 180px;
					margin-left: 40px;
					margin-right: -30px;
		
					.right_down_div {
						display: flex;
						align-items: center;
						float: right;
					}

					.right_tit1 {
						font-size: 24px;
						color: #000;
					}

					.right_tit1:hover {
						color: #006170;
					}

					.commo_span {
						display: flex;
						align-items: center;
						margin-left: 50px;
					}

					.commo_span img {
						width: 20px;
						margin-right: 5px;
					}

				}

				.jieshao {
					font-size: 14px;
					color: #666666;
					clear: both;
					display: block;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					margin-bottom: 30px;
					width: 100%;
					margin-top: 40px;
				}

				.jieshao:hover {
					opacity: 0.8;
				}

				.fenye {
					margin-top: 50px;
					text-align: center;
				}

				.el-pagination.is-background .el-pager li:not(.disabled).active {
					background-color: #006170;
				}
			}
		}
	}
</style>

<style>
	textarea {
		border-radius: 0px !important;
	}
</style>
